module.exports = datalake_event_tracker_v7;